export default "__VITE_ASSET__hIRNapL4__"